<div *ngIf="preloaderService.showSpinner" id="preloader" class="dark-theme" [@inOutAnimation]>
    <div class="pl">
        <div [inlineSVG]="'/assets/kaapisoft-logo.svg'"></div>
        <mat-spinner diameter="24"></mat-spinner>
    </div>
</div>
